import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TokenStorageService } from '../../_common/_service/token-storage.service';
import { CookieService } from 'ngx-cookie-service';

import { MatCarousel, MatCarouselComponent } from '@ngmodule/material-carousel';
import { LoginComponent } from '../../View/authentication/login/login.component';
import { SignupComponent } from '../../View/authentication/signup/signup.component';
import { AuthenticationService } from '../../_common/_service/authentication.service';
import { ChangePasswordComponent } from '../../View/popup/change-password/change-password.component';

import { ProfileComponent } from '../../View/popup/profile/profile.component';
import { MerchantloginComponent } from '../../View/authentication/merchantlogin/merchantlogin.component';
import { CommonService, CommonService1, CommonService2, CartService } from '../../_common/_service/user.service';
import { Router } from '@angular/router';
import { AuthService } from '../../_common/_service/authservice.service';
import { ToastrService } from 'ngx-toastr';
import { NotificationwebComponent } from '../../View/popup/notificationweb/notificationweb.component';
import { MerchantapiComponent } from '../../View/popup/merchantapi/merchantapi.component';
import { AddmerchantstoreComponent } from '../../View/popup/add-merchantstore/add-merchantstore.component';
import { AddmerchantstorelistComponent } from '../../View/popup/add-merchantstorelist/add-merchantstorelist.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { browser } from 'protractor';
import { UpdatereferencialCodeComponent } from '../../View/popup/updatereferencialCode/updatereferencialCode.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']

})

export class HeaderComponent implements OnInit {

  // isUserLoggedIn = false;
  data: any;
  notificationweb: any;
  notificationdataList: any;


  nonotification: any; //
  resultArray: Array<any> = [];
  usersid: Array<any> = [];
  username?: string;
  token: any;
  UsertBal: any;
  currentUser: any;
  messageSuccess: any;
  itemdataList: any;


  //isRefreshed = true;
  //@HostListener('window:beforeunload', ['$event'])
  //onBeforeUnload(event: Event) {
  //  ////////console.log('isrefreshed', this.isRefreshed);
  //  if (!this.isRefreshed) {
  //    this.logout();
  //  }
  //}


  constructor(public dialog: MatDialog, public tokenStorageService: TokenStorageService,
    private modalService: NgbModal, private _cartservice: CartService,
    private _notificationservice: CommonService1, private _balservice: CommonService2,
    private _service: CommonService, private router: Router, private authService: AuthService,
    private toastr: ToastrService, private tokenService: AuthenticationService
    , private cookieService: CookieService
  ) {
    debugger;
    this.currentUser = this.tokenStorageService.getUser();

    this.token = this.tokenStorageService.getToken();

    this.tokenStorageService.getEmployeeDetail2().subscribe(data => {
      debugger;
      //this.currentUser = this.tokenStorageService.getUser();

      this.token = this.tokenStorageService.getToken();

      if (this.token) {
        //this.UsertBal = this.tokenStorageService.getUsertBal();
      }
      if (data != "") {
        this.data = !!this.tokenStorageService.isLoggedIn();

      }
      else {
        this.data = !!this.tokenStorageService.isLoggedIn();
      }
    });

    //when changepwd it logout
    this._service.invokeEvent.subscribe(value => {

      if (value === true) {
        this.logout();
      }
    });
    //when notification post it show
    this._notificationservice.notificationinvokeEvent.subscribe(value => {

      if (value === true) {
        //this.GetCountCurrentWebNotification();
      }
    });
    //when bal post it show
    this._balservice.BalinvokeEvent.subscribe(value => {

      if (value === true) {
        //this.postCookie();

        //this.tokenService.getUserdetailsCurrBal(this.currentUser.serviceid);
      }
    });


    //when bal post it show
    this._cartservice.invokeEvent.subscribe(value => {
      debugger;
      this.token = this._cartservice.getToken();
      var xx = this._cartservice.getItems();
      if (xx != 0) {
        this.itemdataList = xx;
      }
      else {
        this.itemdataList = 0;
      }
    });


  }

  ngOnInit(): void {
    this.postCookie();
    
    

  }

  Back() {
    this.router.navigate(['/Go-on']);
  }

  /*GetCountCurrentWebNotification */
  GetCountCurrentWebNotification() {
    //message: "Http failure response for https://localhost:44390/api/Notification/GetCountCurrentWebNotification?Userid=236&countryid=3&roleid=2: 404 OK"

    //var body = { "Userid": Number(this.currentUser.Userdetailid), "countryid": Number(this.currentUser.serviceid), "roleid": 2 }


    this.authService.GetCountCurrentWebNotification(Number(this.currentUser.Userdetailid), Number(this.currentUser.serviceid), 2).subscribe(response => {
      if (response) {

        if (response != '') {
          this.resultArray = response;
          this.usersid = this.resultArray.map(x => x.id);
          this.notificationdataList = response.length;
        }
        else {
          this.notificationdataList = null;
        }

      }
      else {
        this.toastr.error(response, "Error");
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, "Error");
      } else {
        this.toastr.error(err.error, "Error");
      }
    });
  }


  cartweb() {

    this.router.navigate(['/Cart'], { queryParams: { serviceCode: null }, skipLocationChange: true });

  }

  logout(): void {


    if (this.data == true) {
      //this.isUserLoggedIn = false;
      this.dialog.closeAll();
      localStorage.clear();
      sessionStorage.clear();
      this.modalService.dismissAll();
      //this.tokenStorageService.signOut();
      //window.location.reload();
      this.router.navigate(['/Home']);
      this.data = !!this.tokenStorageService.isLoggedIn();
      //////////console.log("data1" + this.data);
    }
    //sessionStorage.removeItem('IsMobileNoVerified');
    ////invi 
    //sessionStorage.removeItem('LoggedInflag');
    //sessionStorage.removeItem('EmailIdflag');
    //sessionStorage.removeItem('MobileNoflag');
    //sessionStorage.removeItem('FirstNameflag');
    //sessionStorage.removeItem("IsDocVerified");

  }
  openModal() {
    const dialogRef = this.dialog.open(LoginComponent, {
      data: null,
      disableClose: true,
      hasBackdrop: true, // or false, depending on what you want
      width: '720px',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== null && result) {
      }
    });
  }

  openModal1() {
    const dialogRef = this.dialog.open(SignupComponent, {
      data: null,
      disableClose: true,
      hasBackdrop: true, // or false, depending on what you want
      width: '720px',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== null && result) {
      }
    });
  }

  openModal2() {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      //  width: '100%',
      //minHeight: 'calc(100vh - 90px)',
      height: 'auto'

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== null && result) {
      }
    });
  }
  openModal3() {
    const dialogRef = this.dialog.open(ProfileComponent, {
      data: null,
      width: '100%',
      disableClose: true,
      hasBackdrop: true, // or false, depending on what you want
      //minHeight: 'calc(100vh - 90px)',
      height: 'auto'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== null && result) {
      }
    });
  }

  openModal4() {
    const dialogRef = this.dialog.open(MerchantapiComponent, {
      data: null,
      width: '100%',
      disableClose: true,
      hasBackdrop: true, // or false, depending on what you want
      //minHeight: 'calc(100vh - 90px)',
      height: 'auto'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== null && result) {
      }
    });
  }

  openModal5() {
    const dialogRef = this.dialog.open(AddmerchantstoreComponent, {
      data: null,
      width: '35%',
      disableClose: true,
      hasBackdrop: true, // or false, depending on what you want
      //minHeight: 'calc(100vh - 90px)',
      maxHeight: '90vh',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== null && result) {
      }
    });
  }

  openModal6() {
    const dialogRef = this.dialog.open(AddmerchantstorelistComponent, {
      data: null,
      width: '100%',
      disableClose: true,
      hasBackdrop: true, // or false, depending on what you want
      //minHeight: 'calc(100vh - 90px)',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== null && result) {
      }
    });
  }

  openModalMerchantlogin() {
    const dialogRef = this.dialog.open(MerchantloginComponent, {
      data: null,
      width: '100%',
      autoFocus: false,
      disableClose: true,
      hasBackdrop: true, // or false, depending on what you want
      maxHeight: '90vh', //you can adjust the value as per your view
      height: 'auto'

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== null && result) {
      }
    });
  }


  openModalreferencialCode() {
    const dialogRef = this.dialog.open(UpdatereferencialCodeComponent, {
      data: this.currentUser.email,
      width: '100%',
      disableClose: true,
      hasBackdrop: true, // or false, depending on what you want    
      height: 'auto'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined && result !== null && result) {
      }
    });
  }



  GetCookie() {


    this.authService.GetCookie().subscribe(response => {

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, "Error");
      } else {
        this.toastr.error(err.error, "Error");
      }
    });
  }

  //postCookie1() {


  //  this.authService.postCookie().subscribe(response => {
  //    debugger
  //    var cookieVal = response.headers[0].Value[0];

  //    this.cookieService.set('__ssid', cookieVal);
  //    localStorage.setItem('__ssid', cookieVal);
  //  }, (err: any) => {
  //    if (err.error instanceof Error) {
  //      this.toastr.error(err.error, "Error");
  //    } else {
  //      this.toastr.error(err.error, "Error");
  //    }
  //  });
  //}


  async postCookie() {

    this.cookieService.delete('__ssid');
    localStorage.setItem("token", this.token);

  }



}
